import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { PreviousMessageComponent } from './pages/previous-message/previous-message.component';

const routes: Routes = [
  { path: 'tecnic-service', component: HomeComponent },
  { path: 'previous', component: PreviousMessageComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
